import requests from './httpService';

const SchoolUsageService = {
  getSummary(body = {}) {
    return requests.post('/school-usage/summary', body);
  },
  getBySchool(schooleId, body = {}) {
    return requests.post(`/school-usage/${encodeURIComponent(String(schooleId))}`, body);
  },
};

export default SchoolUsageService;
